module.exports = __webpack_public_path__ + "media/images/btn_mares_to_agria-faa5811105bae21d20abb38872cbe396.gif";